import { connectorsForWallets } from "@rainbow-me/rainbowkit";
import {
	coinbaseWallet,
	injectedWallet,
	metaMaskWallet,
	walletConnectWallet,
} from "@rainbow-me/rainbowkit/wallets";
import { http, createConfig } from "wagmi";
import { baseSepolia } from "wagmi/chains";

const projectId =
	import.meta.env.VITE_WALLET_CONNECT_PROJECT_ID || "a70a39aed649413028265ce154e13243";

const connectors = connectorsForWallets(
	[
		{
			groupName: "Popular",
			wallets: [metaMaskWallet, coinbaseWallet, walletConnectWallet, injectedWallet],
		},
	],
	{ appName: "Voidex", projectId },
);

export const config = createConfig({
	chains: [baseSepolia],
	connectors,
	transports: {
		[baseSepolia.id]: http(
			"https://wispy-attentive-choice.base-sepolia.quiknode.pro/72aea9f4ed3715fed05b169b3fd39d262700c6d1/",
		),
	},
});

export { baseSepolia };
